var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVkIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 38,
  height: 38,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  fill: "#7A8090",
  rx: 19
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M30.51 13.376c.17-.565 0-.96-.79-.96h-2.633c-.677 0-.978.358-1.147.753 0 0-1.336 3.273-3.236 5.38-.62.62-.884.809-1.223.809-.17 0-.414-.188-.414-.753v-5.23c0-.677-.188-.959-.752-.959h-4.139c-.414 0-.677.32-.677.602 0 .64.94.79 1.053 2.559v3.875c0 .846-.15.997-.489.997-.884 0-3.066-3.273-4.345-7.036-.264-.696-.508-.997-1.185-.997H7.899c-.752 0-.903.358-.903.753 0 .696.884 4.157 4.157 8.728 2.183 3.123 5.249 4.816 8.033 4.816 1.674 0 1.881-.376 1.881-1.016v-2.37c0-.752.15-.903.696-.903.395 0 1.054.188 2.615 1.693 1.787 1.787 2.088 2.596 3.085 2.596h2.634c.753 0 1.129-.376.903-1.11-.244-.733-1.091-1.806-2.22-3.085-.62-.733-1.542-1.505-1.806-1.9-.395-.508-.282-.733 0-1.166 0-.019 3.217-4.534 3.537-6.076",
  clipRule: "evenodd"
})));
export default SvgVkIcon;